import { Tooltip, TooltipContent, TooltipTrigger } from "../../tooltip/Tooltip";
import { BiQuestionMark } from "react-icons/bi";
import { motion } from "framer-motion";
import TranslatableText from "../../translations/TranslatableText";
import { useIconSize } from "@app/hooks";

const MapGuide = () => {
	const iconSize = useIconSize(20);
	const paramsComponents = [
		<span style={{ fontWeight: 'bold' }} />
	]

	return (
		<Tooltip placement="bottom-start">
			<TooltipTrigger className="d-flex mb-2">
				<motion.div className="d-flex align-items-end pb-1" style={{ borderBottom: "1px solid var(--gray)" }} whileHover={{ backgroundColor: "var(--gray)" }}>
					<TranslatableText translationKey="project.map_guide" className="text-gray ff-medium-cond fs-13" style={{ color: "var(--dark)" }} />
					<BiQuestionMark
						size={iconSize}
						color="#50A2A7" />
				</motion.div>
			</TooltipTrigger>
			<TooltipContent>
				<div className="map-guide-tooltip-content" style={{ maxWidth: 700 }}>
					<h3 className="fs-18 ff-medium-cond"><TranslatableText translationKey="map_guide.step_title" /></h3>
					<h4 className="ff-medium-cond pt-2 fs-18"><TranslatableText translationKey="map_guide.access_the_analysis_tool" /></h4>
					<ul className="fs-14 ps-2">
						<li><TranslatableText translationKey="map_guide.step_instruction_1" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_2" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_3" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_4" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_5" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_6" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_7" paramsComponents={paramsComponents} /></li>
						<li><TranslatableText translationKey="map_guide.step_instruction_8" paramsComponents={paramsComponents} /></li>
					</ul>

					<p className="ff-medium-cond pt-2 fs-18"><TranslatableText translationKey="map_guide.download_instruction" /></p>
				</div>
			</TooltipContent>
		</Tooltip>
	)
}

export default MapGuide; 